import React from "react";
import { ChangePasswordResponseStatus } from "../../../api/changePassword";

const PasswordRenewFormError: React.FC<PasswordRenewFormErrorProps> = ({
  error,
}) => {
  switch (error) {
    case "INVALID_PASSWORD_LENGTH":
    case "INVALID_PASSWORD_SYMBOL":
      return (
        <>
          Das von dir eingegebene Passwort entspricht nicht unseren Richtlinien.
          Bitte überprüfe deine Eingabe.
        </>
      );
    case "IDENTICAL_USERNAME_AND_PASSWORD":
      return (
        <>
          Das von dir eingegebene Passwort darf nicht deinem meincongstar
          Benutzernamen entsprechen. Bitte überprüfe deine Eingabe.
        </>
      );
    case "INCORRECT_BIRTHDATE":
      return (
        <>
          Das von dir eingegebene Geburtsdatum entspricht nicht dem im
          Kundencenter meincongstar hinterlegten. Bitte überprüfe deine Eingabe.
        </>
      );
    case "INVALID_TOKEN":
      return (
        <>
          Leider ist dein persönlicher Link ungültig. Das kann daran liegen,
          dass er entweder älter als 24 Stunden und daher abgelaufen ist oder
          weil er bereits verwendet wurde.
        </>
      );
    default:
      return <></>;
  }
};

export type PasswordRenewFormErrorProps = {
  error: ChangePasswordResponseStatus;
};

export default PasswordRenewFormError;
